module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.SitePage_About":{"widgets.aboutMe.widgets.socialApps.widget":[{"value":"SocialApps","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101006},"path":"~.SitePage_About","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/options/sitepage/about.js
// module id = 682
// module chunks = 4